var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68493 11.1991C5.44493 11.1991 5.22491 11.1191 5.04491 10.9391L1.06493 6.95906C0.704932 6.59906 0.704932 6.03907 1.06493 5.67907C1.42493 5.31907 1.98491 5.31907 2.34491 5.67907L5.70492 9.01906L13.6849 1.05906C14.0449 0.69906 14.6049 0.69906 14.9649 1.05906C15.3249 1.41906 15.3249 1.97906 14.9649 2.33906L6.34491 10.9391C6.14491 11.1191 5.92493 11.1991 5.68493 11.1991Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheckMark);
export default __webpack_public_path__ + "static/media/checkbox-check-mark.5972ad56bd3f769a0706efcb49c87e27.svg";
export { ForwardRef as ReactComponent };